module.exports = __webpack_public_path__ + "img/quinton.1d2a3b54.svg";